// components/Programs.js (Updated with images)
import React from 'react';
import './Programs.css';
import { images } from '../utils/images';

const Programs = () => {
  const programs = [
    {
      title: 'Education Initiative',
      description: 'Providing quality education and learning resources to underprivileged children',
      image: images.programs.education
    },
    {
      title: 'Healthcare Access',
      description: 'Free medical camps and health awareness programs in rural areas',
      image: images.programs.healthcare
    },
    {
      title: 'Women Empowerment',
      description: 'Skill development and entrepreneurship programs for women',
      image: images.programs.women
    },
    {
      title: 'Environmental Conservation',
      description: 'Tree plantation drives and sustainable living workshops',
      image: images.programs.environment
    },
    {
      title: 'Youth Development',
      description: 'Career guidance and vocational training for young adults',
      image: images.programs.youth
    },
    {
      title: 'Rural Development',
      description: 'Infrastructure and sanitation improvements in villages',
      image: images.programs.rural
    }
  ];

  return (
    <section id="programs" className="programs">
      <div className="container">
        <h2 className="section-title">Our Programs</h2>
        <p className="section-subtitle">Making a difference through targeted interventions</p>
        <div className="programs-grid">
          {programs.map((program, index) => (
            <div key={index} className="program-card">
              <div className="program-image">
                <img src={program.image} alt={program.title} />
              </div>
              <div className="program-content">
                <h3>{program.title}</h3>
                <p>{program.description}</p>
                <a href="#" className="learn-more">Learn More →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;